var script = function() {
  this.video;
  this.recorder;
  this.startBtn;
  this.stopBtn;
  this.callback = function() {};

  this.captureCamera = function(callback) {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(function(camera) {
        callback(camera);
      })
      .catch(function(error) {
        alert("Unable to capture your camera. Please check console logs.");
        console.error(error);
      });
  };

  this.stopRecordingCallback = function() {
    this.video.src = this.video.srcObject = null;
    this.video.muted = false;
    this.video.volume = 1;
    this.video.src = URL.createObjectURL(this.recorder.getBlob());
    this.callback(this.recorder.getBlob());
    this.recorder.camera.stop();
    this.recorder.destroy();
    this.recorder = null;
  };

  (this.recordCamera = function(camera) {
    this.video.muted = true;
    this.video.volume = 0;
    this.video.srcObject = camera;

    this.recorder = this.RecordRTC(camera, {
      type: "video",
      frameRate: 20,
      bitrate: 128000,
      elementClass: "multi-streams-mixer",
      canvas: {
        width: 640,
        height: 480
      }
    });
    this.recorder.startRecording();

    // release camera on stopRecording
    this.recorder.camera = camera;

    this.stopBtn.disabled = false;
  }),
    (this.listener = function() {
      this.startBtn.onclick = function() {
        this.video.classList.remove("hidden");
        this.startBtn.disabled = true;
        this.stopBtn.disabled = false;
        this.captureCamera(
          function(camera) {
            this.recordCamera(camera);
          }.bind(this)
        );
      }.bind(this);

      this.stopBtn.onclick = function() {
        this.stopBtn.disabled = true;
        this.startBtn.disabled = false;
        this.recorder.stopRecording(this.stopRecordingCallback);
      }.bind(this);
    });
};

export { script };
